// @ts-nocheck

import palette from '../palette';

export const MyMatch = {
  itemBackgroundColorOdd: palette.bluegrey850,
  itemBackgroundColorEven: palette.neutralgrey800,
  itemHoverBackgroundColor: palette.bluegrey700,
  activeItemBackgroundColor: palette.yellowwinamax450,
  activeItemHoverBackgroundColor: palette.gold200,
  activeItemColor: palette.black,
  outcomeDisabledColor: palette.silver340,
  outcomeHeaderColor: palette.yellowwinamax450,
  outcomeHeaderBackgroundColor: palette.bluegrey850,
  modalHeaderColor: palette.bluegrey850,
  matchHeaderColor: palette.neutralgrey350,
  matchHeaderBackgroundColor: palette.bluegrey925,
  outcomeColor: palette.white,
  addSelectionBackgroundColor: palette.white,
  addSelectionColor: palette.black,
  oddBackgroundColor: palette.bluegrey925,
  oddLabelColor: palette.neutralgrey200,
  oddValueColor: palette.yellowwinamax450,
  seeSelectionButtonBackgroundColor: palette.bluegrey700,
  redButtonBackgroundColor: palette.red200,
  redButtonColor: palette.white,
  newLabelColor: palette.yellowwinamax450,
  errorBackgroundColor: palette.red100,
  footerBorderColor: palette.neutralgrey800,
  emptyBetlistBackgroundColor: palette.bluegrey850,
  addSelectionButtonColor: palette.black,
};

export const MyMatchDynamicBackground = {
  mainColor: palette.mmRadialRed,
  defaultBackgroundColor: palette.bluegrey900,
};
